import React from "react";
import { createRoot } from "react-dom/client";
import App from "components/App";
// seems silly, but the <App /> component needs to use the useLocation hook
// which is only available in children of the <Router />
import { HashRouter as Router } from "react-router-dom";

const mount = document.getElementById("real-id-mount");

try {
  // try mounting immediately.
  document.addEventListener("DOMContentLoaded", () => {
    createRoot(mount).render(
      <Router>
        <App />
      </Router>
    );
  });
  // some plugins hydrate the DOM with JavaScript and make it impossible to mount immediately.
  // so we'll try again once the document is ready
} catch (error) {
  console.log("Unable to mount immediately, observing the DOM");
  const observer = new MutationObserver(() => {
    const mountNode = document.getElementById("real-id-mount");
    if (mountNode) {
      console.log("Mounting the app");
      observer.disconnect();
      ReactDOM.createRoot(mountNode).render(<App />);
    } else {
      console.log("Unable to mount, no mount node found");
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}
